/**
 * Enum for enumeration order.
 * @enum {string}
 */
export enum EnumerationOrderEnum {
  CreatedAscending = 'CreatedAscending', // Created ascending order
  CreatedDescending = 'CreatedDescending', // Created descending order
  NameAscending = 'NameAscending', // Name ascending order
  NameDescending = 'NameDescending', // Name descending order
  GuidAscending = 'GuidAscending', // GUID ascending order
  GuidDescending = 'GuidDescending', // GUID descending order
  CostAscending = 'CostAscending', // Cost ascending order
  CostDescending = 'CostDescending', // Cost descending order
}
